import { FunctionComponent } from 'react'

import { EntityType } from '@utils/entities'
import translate from '@i18n'
import useSportEntitySchedule, {
  AllowedTypeOfSport,
} from '@hooks/useSportEntitySchedule'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import MessageBox from '@components/RelatedMatches/MessageBox'
import SportEntityScheduleComponent from '@components/SportEntitySchedule'
import { SvgIconName } from '@components/SvgIcon/types'

type SportEntityScheduleApiProps = {
  typeOfSport: AllowedTypeOfSport
  competitorId?: string
  entityType: EntityType
}

const SportEntitySchedule: FunctionComponent<SportEntityScheduleApiProps> = ({
  competitorId,
  typeOfSport,
  entityType,
}) => {
  const { data, error, isSuccess, isEnabled } = useSportEntitySchedule({
    competitorId,
    typeOfSport,
  })
  const items = data?.items
  const isDataEmpty = isSuccess && !items?.length

  const errorMessage = error
    ? {
        iconName: 'user-robot-xmarks-solid' as SvgIconName,
        title: translate('network.error.title'),
        text: translate('network.error.text'),
      }
    : isDataEmpty
      ? {
          iconName: 'calendar-clock' as SvgIconName,
          title: translate('sports.emptyData.title'),
          text: translate('sports.emptyData.text'),
        }
      : undefined

  if (!isEnabled) {
    return null
  }

  return errorMessage ? (
    <MessageBox
      iconName={errorMessage.iconName}
      title={errorMessage.title}
      text={errorMessage.text}
    />
  ) : (
    entityType === 'competitor' && (
      <SportEntityScheduleComponent items={items} />
    )
  )
}

const widget = {
  kind: ['sport-entity-schedule'],
  component: SportEntitySchedule,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
